import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'

import { userActions } from '../../store/private/user';

const Logout = props => {
    props.logout();
    return (
        <Redirect to="/login" />
    )
}

export default connect( null, dispatch => bindActionCreators({ ...userActions }, dispatch))(Logout);


// WEBPACK FOOTER //
// ./src/pages/private/logout.js